import {
    FETCH_APPOINTMENTS_REQUEST,
    FETCH_APPOINTMENTS_SUCCESS,
    FETCH_APPOINTMENTS_FAILURE,
    FETCH_APPOINTMENTS_COUNT_REQUEST,
    FETCH_APPOINTMENTS_COUNT_SUCCESS,
    FETCH_APPOINTMENTS_COUNT_FAILURE,
    FETCH_APPT_REQUESTLIST_REQUEST,
    FETCH_APPT_REQUESTLIST_SUCCESS,
    FETCH_APPT_REQUESTLIST_FAILURE,
    FETCH_TODAY_APPOINTMENTS_REQUEST,
    FETCH_TODAY_APPOINTMENTS_SUCCESS,
    FETCH_TODAY_APPOINTMENTS_FAILURE,
} from "../actions/appointmentActions";

const initialState = {
    appointmentsList: [],
    todaysAppointmentsList:[],
    requestsList:[],
    totalCount: 0,
    isLoading: false,
    countLoading:false,
    error: null
};

export const appointmentsReducer = (state = initialState, action) => {
    switch (action.type) {
        case FETCH_APPOINTMENTS_REQUEST:
            return { ...state, isLoading: true };

        case FETCH_APPOINTMENTS_SUCCESS:
            return { ...state, appointmentsList: action.payload,isLoading: false};

        case FETCH_APPOINTMENTS_FAILURE:
            return { ...state, error: action.payload, isLoading: false };

         case FETCH_TODAY_APPOINTMENTS_REQUEST:
            return { ...state, isLoading: true };

        case FETCH_TODAY_APPOINTMENTS_SUCCESS:
            return { ...state, todaysAppointmentsList: action.payload,isLoading: false};

        case FETCH_TODAY_APPOINTMENTS_FAILURE:
            return { ...state, error: action.payload, isLoading: false };

        case FETCH_APPOINTMENTS_COUNT_REQUEST:
            return { ...state, countLoading: true };

        case FETCH_APPOINTMENTS_COUNT_SUCCESS:
            return { ...state, totalCount: action.payload, countLoading: false };

        case FETCH_APPOINTMENTS_COUNT_FAILURE:
            return { ...state, error: action.payload, countLoading: false };

        case FETCH_APPT_REQUESTLIST_REQUEST:
            return { ...state, isLoading: true };

        case FETCH_APPT_REQUESTLIST_SUCCESS:
            return { ...state, requestsList: action.payload,isLoading: false};

        case FETCH_APPT_REQUESTLIST_FAILURE:
            return { ...state, error: action.payload, isLoading: false };

        default:
            return state;
    }
};
